import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3da34a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "loader-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "actions" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Is that correct?")
], -1))
const _hoisted_12 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SomethingWrongOverlay = _resolveComponent("SomethingWrongOverlay")!

  return (_ctx.commitError)
    ? (_openBlock(), _createBlock(_component_SomethingWrongOverlay, {
        key: 0,
        message: `${_ctx.commitError.name} ${_ctx.commitError.statusCode}: ${_ctx.commitError.message}`
      }, null, 8, ["message"]))
    : (typeof _ctx.activeLoad === 'undefined' && !_ctx.commitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("main", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.showSystemPta)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _createTextVNode(" We show you're available to pick up a load "),
                  _createElementVNode("span", null, [
                    (_ctx.todayOrTomorrowText)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_7, _toDisplayString(_ctx.todayOrTomorrowText), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(_ctx.todayOrTomorrowText && ',') + " ", 1),
                    (!_ctx.todayOrTomorrowText)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "on "))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.dateText) + " ", 1),
                    _createElementVNode("b", null, "at " + _toDisplayString(_ctx.timeText), 1),
                    _createTextVNode(". ")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, " We show you're currently available to pick up a load. "))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleYesClick && _ctx.handleYesClick(...args))),
                class: "btn btn-lg btn-primary"
              }, " Yes "),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNoClick && _ctx.handleNoClick(...args))),
                class: "btn btn-lg btn-primary"
              }, " No ")
            ])
          ])
        ]))
}